import React, { Component } from 'react';

import Portal from './Portal';

export default function renderInPortalWithGroup(WrappedComponent) {
  return class extends Component {
    render() {
      return (
        <Portal>
          <WrappedComponent {...this.props} />
        </Portal>
      );
    }
  };
}
